// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

if (!customElements.get('section-articles')) {
  customElements.define(
    'section-articles',
    class ArticlesCarousel extends window.BAO.CustomElement() {
      constructor () {
        super()

        if (!this.els.slide) return

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        if (window.innerWidth > 767) {
          this.els.slides.element.classList.remove('car-Carousel_Slides')

          this.els.slide.elements.forEach(slide => {
            slide.classList.remove('car-Carousel_Slide')
          })

          return
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          centered: true,
          loop: true,
          slidesPerView: 1.3,
          spacing: 15,
          slides: '.car-Carousel_Slide',
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.setAttribute('data-initialized', 'true')
          }
        })
      }
    },
  )
}
